import React from "react";
import {useAxiosSetup} from "../Api";
import {useLocation, useNavigate} from "react-router-dom";
import {useModal} from "../dialogs/ModalContext";
import PopupWarning from "../dialogs/PopupWarning";


function QRHandler(props) {
    const location = useLocation()
    const navigate = useNavigate();
    const qrString = location.pathname.split('/').filter(Boolean).pop();
    const {showModal} = useModal();

    const api = useAxiosSetup();

    React.useEffect(() => {
        api.get(`/qr/${qrString}/`).then((response) => {
            const qrName = response.data.qrName
            const qrValue = response.data.qrValue
            if (qrName === 'serviceCase') {
                navigate(`/service_cases/service_case/${qrValue}`)
            } else if (qrName === 'activeLoan') {
                navigate(`/loans/loan/${qrValue}`)
            } else if (qrName === 'newLoan') {
                navigate(`/loans/loan/new`, {state: { instrumentId: qrValue}} )
            } else {
                showModal(PopupWarning, 'Neplatný QR kód', () => { navigate(-1) })
            }

        }).catch(
            (error) => {
                showModal(PopupWarning, 'Neplatný QR kód', () => { navigate(-1) })
            }
        )
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    return (
        <div>

        </div>
    )
}

export default QRHandler
